<template>
  <div class="idor-vul">
    <!-- Request Information Section -->
    <div class="idor-section">
      <h3>{{ $t('vulnerabilityInformation.requestInformation') }}</h3>
      <el-table
        :data="requestData"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="item"
          :label="$t('vulnerabilityInformation.item')"
          width="180"
        />
        <el-table-column
          prop="information"
          :label="$t('vulnerabilityInformation.information')"
        />
      </el-table>
    </div>

    <!-- Response Information Section -->
    <div class="idor-section">
      <h3>{{ $t('vulnerabilityInformation.responseInformation') }}</h3>
      <el-table
        :data="responseData"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="item"
          :label="$t('vulnerabilityInformation.item')"
          width="180"
        />
        <el-table-column
          prop="information"
          :label="$t('vulnerabilityInformation.information')"
        />
      </el-table>
    </div>

    <div class="moduleWrapper">
      <!-- POC Script section -->
      <div
        class="codeWrapper"
        v-if="poc"
      >
        <h3 style="margin-bottom: 8px">{{ $t('vulnerabilityInformation.proofOfConcept') }}</h3>
        <div class="codeTitle">
          <h3>HTML</h3>
          <img
            src="@assets/codeScan/code_scan_fff.png"
            @click="copyOxpeckerIp(poc)"
          />
        </div>
        <CodeMirror
          :value="poc"
          :options="{
                mode: 'text/html',
                theme: 'base16-dark',
                lineNumbers: true,
                line: true,
                readOnly: true,
              }"
        />
      </div>
    </div>

    <!-- Detection Criteria Section -->
    <div class="idor-section">
      <h3>{{ $t('vulnerabilityInformation.detectionCriteria') }}</h3>
      <div class="code-block">
        <pre><code>{{ detectionCriteria }}</code></pre>
      </div>
    </div>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';

require('codemirror/mode/htmlmixed/htmlmixed');
require('codemirror/theme/base16-dark.css');

export default {
  name: 'CsrfVul',
  props: {
    vul: {
      type: Object,
      required: true,
    },
  },
  components: {
    CodeMirror: codemirror,
  },
  computed: {
    requestData() {
      const { apiPath, apiMethod, pocScript } = this.vul;
      let postData = '-';
      let requestHeaders = '-';

      // 如果存在 pocScript，尝试解析获取 postData
      if (pocScript) {
        try {
          const pocData = JSON.parse(pocScript);
          postData = pocData.postData || '-';
          requestHeaders = pocData.headers || '-';
        } catch (e) {
          console.warn('Failed to parse pocScript:', e);
          postData = '-';
        }
      }

      return [
        {
          item: 'URL',
          information: apiPath,
        },
        {
          item: 'Method',
          information: apiMethod,
        },
        {
          item: 'Request Headers',
          information: JSON.stringify(requestHeaders),
        },
        {
          item: 'Request Body',
          information: postData,
        },
        {
          item: 'Account Role',
          information: 'Administrator',
        },
      ];
    },
    responseData() {
      if (!this.vul.pocScriptOutput) return [];

      const output = JSON.parse(this.vul.pocScriptOutput);
      return [
        {
          item: 'Response Body',
          information: output.responses.original,
        },
        {
          item: 'Status Code',
          information: output.statusCodes.original,
        },
      ];
    },
    // similarityData() {
    //   if (!this.vul.pocScriptOutput) return [];

    //   const output = JSON.parse(this.vul.pocScriptOutput);
    //   return [
    //     {
    //       requestType: 'Replay',
    //       similarity: output.similarities.originalVsOriginal?.similarity,
    //     },
    //     {
    //       requestType: 'WithoutCookie',
    //       similarity: output.similarities.originalVsWithoutCookie?.similarity,
    //     },
    //     {
    //       requestType: 'WithoutToken',
    //       similarity: output.similarities.originalVsWithoutToken?.similarity,
    //     },
    //     {
    //       requestType: 'WithoutReferer',
    //       similarity: output.similarities.originalVsWithMockReferer?.similarity,
    //     },
    //   ].filter((item) => item.similarity);
    // },
    detectionCriteria() {
      if (!this.vul.pocScriptOutput) return '';

      try {
        const output = JSON.parse(this.vul.pocScriptOutput);
        return output.reasoning || '';
      } catch (error) {
        console.error('Failed to parse POC script output:', error);
        return '';
      }
    },
    poc() {
      if (!this.vul.pocScriptOutput) return '';

      try {
        const output = JSON.parse(this.vul.pocScriptOutput);
        const pocStr = output.poc;
        if (pocStr) {
          // Extract code content from markdown code block format "```html\nCode\n```"
          const codeBlockMatch = pocStr.match(/```html\n([\s\S]*?)\n```/);
          if (codeBlockMatch) {
            return codeBlockMatch[1].replace(/\\n/g, '\n');
          }
          return pocStr.replace(/\\n/g, '\n');
        }
        return '';
      } catch (error) {
        console.error('Failed to parse POC script output:', error);
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.idor-vul {
  .idor-section {
    margin-bottom: 30px;
  }

  h3 {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
  }

  .code-block {
    background: #1e1e1e;
    border-radius: 4px;
    padding: 16px;

    pre {
      margin: 0;

      code {
        color: #fff;
        font-family: monospace;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
  }

  :deep(.el-table) {
    margin-bottom: 16px;

    .el-table__header-wrapper {
      th {
        background-color: #2b2b2b;
        color: #ffffff;
      }
    }
  }
}
</style>
